import {
  EcommercePublicKeyAction,
  LOAD_ECOMMERCE_PUBLIC_KEY,
  LOAD_ECOMMERCE_PUBLIC_KEY_FAIL,
  LOAD_ECOMMERCE_PUBLIC_KEY_SUCCESS,
  LoadEcommercePublicKey,
  LoadEcommercePublicKeyFail,
  LoadEcommercePublicKeySuccess,
} from "../actions";

export interface IEcommercePublicKeyEntityState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommercePublicKeyState {
  entities: { [websiteId: number]: IEcommercePublicKeyEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommercePublicKeyState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommercePublicKeyState = initialState, action: EcommercePublicKeyAction): IEcommercePublicKeyState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_PUBLIC_KEY:
      payload = (<LoadEcommercePublicKey>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_PUBLIC_KEY_SUCCESS:
      payload = (<LoadEcommercePublicKeySuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_PUBLIC_KEY_FAIL:
      payload = (<LoadEcommercePublicKeyFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
